/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import SelectWithSearch from 'src/components/SelectWithSearch/view';
import { useApplicationsApi } from 'src/modules/applications/api';
import { pointerCursorSx } from '../../helpers';

interface ApplicationIdsFieldProps {
  values: string[];
  onChange: (values: string[]) => void;
  visible: boolean;
  required: boolean;
  isSelected: boolean;
  onClick: () => void;
}

export const ApplicationIdsField: React.FC<ApplicationIdsFieldProps> = ({
  values,
  onChange,
  visible,
  onClick,
}) => {
  const [applications, setApplications] = useState<any[]>([]);
  const [applicationsLoading, setApplicationsLoading] = useState(false);
  const applicationsApi = useApplicationsApi();

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        setApplicationsLoading(true);
        const response = await applicationsApi.getAdminApplications({
          limit: 1000,
          offset: 0
        });
        setApplications(response.data.items || []);
      } catch (error) {
        console.error('Failed to fetch applications:', error);
        setApplications([]);
      } finally {
        setApplicationsLoading(false);
      }
    };

    if (visible) {
      fetchApplications();
    }
  }, [applicationsApi, visible]);

  const applicationOptions = applications.map(app => ({
    value: app.id,
    text: app.name || `Application ${app.id}`
  }));

  const handleSelectChange = (
    _event: React.SyntheticEvent | undefined,
    items: { value: string; text: string }[],
  ) => {
    if (!visible) return;
    const selectedIds = items.map(item => item.value);
    onChange(selectedIds);
  };

  return (
    <Box onClick={onClick} sx={pointerCursorSx}>
      <SelectWithSearch
        label=""
        placeholder={values.length === 0 ? "Global Campaign" : "Select applications"}
        options={applicationOptions}
        values={values}
        handleSelectChange={handleSelectChange}
        style={{
          width: '100%',
          opacity: visible ? 1 : 0.7
        }}
        disabled={applicationsLoading}
      />
    </Box>
  );
};